<template>
  <v-container>
    <v-layout>
      <v-flex>
        <p>{{$tf('NoUploadableText', {limit})}}</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'no-uploadable',
    props: {
      limit: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        showMore: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogNoUploadable.vue